module.exports = __webpack_public_path__ + "img/11.17ce2fd8.png";